<template>
    <div>
        <div>
            <v-hover><v-chip 
            slot-scope="{ hover }"
            :class="`caption font-weight-thin text-uppercase mb-2 ml-2 text-center elevation-${hover ? 3 : 0}`"
            @click="close" absolute top left>
            <v-icon>keyboard_arrow_left</v-icon>back</v-chip></v-hover>

            <BasicCard
                v-bind:title="`Nuovo intervento`">
                <OperationRegistry
                    ref="registry"
                    :o_data="{}"
                    v-on:update_op_registry="updateValidity"
                />
                <v-form v-model="valid" ref="operationRef">
                <v-container>
                <v-row no-gutters>
                    <v-col cols="4">
                        <v-checkbox dense
                            v-model="r_type_select"
                            label="solo un tipo di report "
                        />
                    </v-col>
                    <v-col cols="4">
                        <v-autocomplete dense outlined
                            v-if="r_type_select" 
                            v-model="op.op_type"
                            label="report"
                            :items="op_types"
                            item-text="name"
                            item-value="id"
                            return-value="id"
                            />
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="8">
                        
                        <v-btn v-if="enable_piva_search" color="action" @click="openPIVADialog"><v-icon small class="ma-1">search</v-icon>Partita IVA</v-btn>
                        <v-autocomplete dense outlined
                            ref="clientRef"
                            v-model="op.client_id"
                            label="cliente"
                            :loading="c_loading"
                            hide-no-data
                            :items="s_clients"
                            item-text="value.name"
                            item-value="_id"
                            :disabled="s_clients.length==0"
                            clearable
                            @change="changeClient"
                            @click:clear="resetOpClient"
                            :rules="[rules.mandatory]"
                            class="py-2" 
                            />
                    </v-col>
                    <v-col cols="4" class="d-flex  pl-4 justify-end">
                        <v-btn text @click="addNewClient"><v-icon small class="ma-1">add_box</v-icon>cliente</v-btn>
                    </v-col>
                </v-row>
                
                <div v-if="op.client_id">
                    <v-row no-gutters>
                        <v-col cols="8">
                            <v-autocomplete dense outlined
                                v-model="op.location_id"
                                label="sede*"
                                hide-no-data
                                :items="s_locations"
                                no-data-text="crea sede"
                                item-text="value.name" 
                                item-value="_id"
                                clearable
                                :disabled="s_locations.length==0"
                                :rules="[rules.mandatory]"
                            />
                        </v-col>
                        <v-col cols="4" class="d-flex pl-4 justify-end">
                            <v-btn text @click="addNewLocation"><v-icon small class="ma-1">add_box</v-icon>sede</v-btn>
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="op.client_id && op.location_id">
                        <v-col cols="12">
                            <OpInstrumentSelection
                                ref="instrumentsSelection"
                                :client_id="op.client_id"
                                :location_id="op.location_id"
                                :operation_org_id="op.org_id"
                                :key="op.client_id+'_'+op.location_id"
                                :show_platform_capacity="true"
                                :op_type="op.op_type"
                                :selected_departments="op.department_ids"
                                :selected_instruments="op.instrument_ids"
                            >
                            </OpInstrumentSelection>
                        </v-col>
                    </v-row>
                
                </div>
                </v-container>
                <div class="pa-4">
                    <v-alert
                        v-if="save_error"
                        dense
                        type="warning"
                        >
                        <div class="d-flex flex-column">
                            <div class="font-weight-bold">Salvataggio fallito</div>
                            <div>Riprovare oppure segnalare il problema all'amministratore di sistema.</div>
                        </div>
                    </v-alert>
                </div>
                <div class="d-flex align-center justify-center">
                    <v-btn class="ma-2" color="primary" :disabled="!isValid" @click.stop="saveOperation">salva</v-btn>
                    <v-btn class="ma-2" text @click.stop="close">annulla</v-btn>
                </div>
                        
                </v-form>
            </BasicCard>

        <ClientDialog
            ref="clientEdit"
            v-bind:allowCreateLocation="false"
            v-on:addClient="refreshClient"
        />
        <LocationEdit
            v-if="op.client_id"
            ref="locationEdit"
            v-bind:client_id="op.client_id"
            v-bind:enable_registered="true"
            v-on:locationDialogClosed="refreshLocation"
            v-on:add_contact="addContact(null)"
        />
        <BaseDialog
        :dialog="piva_dialog.open"
        v-on:close_dialog="closePIVADialog"
        :max_width="`600`"
        >
            <template v-slot:title>
                Cerca per Partita IVA
            </template>
            <div>
                <div class="text-h6">Ricerca nel sistema</div>
                    <v-row no-gutters>
                    <v-col cols="6" class="d-flex justify-start align-content-center pr-2">
                        <v-text-field dense outlined
                            label="PIVA"
                            v-model="piva_dialog.search_piva"
                            :rules="[rules.piva]"
                            clearable
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-start align-content-center">
                        <v-btn color="primary" class="d-flex align-content-center text-center" @click="exactSearch"><v-icon class="pr-2">search</v-icon>Cerca</v-btn>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="piva_dialog.show_result">
                    <v-col cols="12">
                        <div v-if="!piva_dialog.result || piva_dialog.result.length == 0">Nessun risultato
                            <div class="d-flex align-center justify-center">
                            <v-btn class="ma-2" text @click.stop="closePIVADialog">chiudi</v-btn>
                            </div>
                        </div>
                        <div v-else-if="piva_dialog.result.length == 1">
                            {{piva_dialog.result[0].value.piva}} - {{piva_dialog.result[0].value.name}}
                            <div class="d-flex align-center justify-center">
                                <v-btn class="ma-2" color="primary" @click.stop="closePIVADialog(piva_dialog.result[0].id)">scegli cliente</v-btn>
                                <v-btn class="ma-2" text @click.stop="closePIVADialog()">annulla</v-btn>
                            </div>
                        </div>
                        <div v-else>
                            Anomalia nel sistema, contattare l'amministratore:
                            <div v-for="res of piva_dialog.result" :key="res.id">
                                {{res.value.piva}} - {{res.value.name}}
                            </div>
                            <div class="d-flex align-center justify-center">
                                <v-btn class="ma-2" text @click.stop="closePIVADialog()">annulla</v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </BaseDialog>
        <ContactDialog
            ref="contactEdit"
            v-on:contact_update="updateContact"
        />
    </div> 
    </div>
</template>
<script>

// import _ from 'lodash'
//import {TemporaryManagement} from '../../utils/temporaryManagement.js'
import {i_families, report_type} from "../../utils/common.js"
import BasicCard from "../../components/utils/Basic_card"
import BaseDialog from "../../components/dialogs/BaseDialog"
import {getModel} from '../../utils/model'
import {searchDesign, orderByFields} from '../../utils/dbUtility.js'
import ContactDialog from "../clients/ContactDialog"
import LocationEdit from "../clients/LocationEdit"
import ClientDialog from "../clients/ClientDialog"
import OperationRegistry from './OperationRegistry'
import OpInstrumentSelection from './OpInstrumentSelection'
import { filterByOrg } from '../../utils/rolesManagement'
import { f_rules } from '../../utils/commonUtils'



export default {
    props: {
        'client_id': {
            type: String,
            required: false,
            default: null
        }, 
        'location_id': {
            type: String,
            required: false,
            default: null
        }, 
        'department_id': {
            type: String,
            required: false,
            default: null
        },
        'instr_ids': {
            type: Array,
            required: false,
            default: null
        },
        'back':{
            type: String,
            required: false,
            default: '/operations/'
        }
    },
    // source is the source operations db to be modified 
//    mixins: [TemporaryManagement],
    components: {
        BasicCard, LocationEdit, ClientDialog,  OperationRegistry, OpInstrumentSelection, BaseDialog, ContactDialog
    },

    data(){
        return{
            families: i_families,
            c_loading: false,
            all_instrument: false,
            s_clients:[],
            s_locations: [],
            //validationStep: false,
            op: {},
            ext_data: this.reset(),
            rules: f_rules,
            op_types: Object.values(report_type),
            valid: false,
            dateFormatted: "",
            order_date: "",
            menuOrder: false,
            menuOpDate: false,
            dateOpFormatted: "",
            op_date: "",
            r_type_select: false,
            regValid: false,
            enable_piva_search: false,
            piva_dialog: {
                open: false,
                search_piva: "",
                result: null,
                show_result: false
            },
            save_error: false
        }
    },
    /*pouch: {
        // The function returns a Mango-like selector that is run against the `people` database.
        // The result of the query is assigned to the `people` property.
        s_locations() {
            // console.log("*******", this.op)
            if (!this.op || !this.op.client_id) return;
            return {
                database: "registry",
                selector: {client_id: this.op.client_id, doc_type:'location'}
            }
        }
    },*/
    async mounted() {
        // console.log('MOUNTED *****', )
        this.doc_type = 'operation'
        this.save_error = false
        
        
        await this.initObjectData()
        this.$nextTick(function(){
            this.$refs.operationRef.validate()
        })
        this.enable_piva_search = filterByOrg('client', 'view_org', this.$store.state.user.roles)
        //this.ext_data = await this.initData(this.op) // await this.initExt_data(this.op) //.then((res) => {
        
    },
    created(){
        /*this.debouncedClient = _.debounce(function(){
            // console.log('debouncedClient')
            this.searchClient()
        },300)*/
    },
    methods: {
        async initObjectData() {
            // console.log('OPERATION EDIT initObjectData')
            let Operation = getModel("Operation");
            let operation = Operation({
                client_id: this.client_id ? this.client_id : '',
                location_id: this.location_id ? this.location_id : '',
                instrument_ids: this.instr_ids ? this.instr_ids : [],
                created_by: this.$store.state.user._id
            })
            if (this.department_id) {
                operation.department_ids = [this.department_id]
            }
            this.op = operation
            await this.getClients()
            let idx = _.findIndex(this.clients, function(c) { return c._id == this.client_id; })
            if ( this.client_id && idx ==-1) {
                let result = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', this.client_id, false)
                console.log(result)
                let added_client = {_id: result[0].id, value: result[0].value}
                this.$set(this.s_clients, this.s_clients.length, added_client)
            }
            /*let OpType = getModel("OpType")
            for (let key of Object.keys(operation.op_types)) {
                operation.op_types[key] = OpType()
            }
            console.log("OPERATION", operation.op_types)*/
            // return operation
        },
        addNewLocation(){
            // TODO open a new dialog to edit the location
            this.$refs.locationEdit.openDialog(this.op.client_id, null);
        },
        addNewClient() {
            this.$refs.clientEdit.openDialog(false);
        },
        changeClient() {
            this.$set(this.op, 'location_id', null)
            this.getLocations()
        },
        resetOpClient() {
            this.$set(this.op, 'client_id', null)
            this.$set(this.op, 'location_id', null)
            //console.log('OPPPP', this.op)
        },
        async updateCheck(){
            if (!this.op.check) {
                let OpCheck = getModel("OpCheck");
                this.op.check = OpCheck()
            }
            this.op.check['order'] = true
            let found_locations = this.s_locations.filter(loc => { 
                if (loc._id == this.op.location_id) {
                    return loc 
                } 
            })
            this.op.check['location'] = found_locations[0].complete
            let client = await this.$store.state.$pouch.get('registry', this.op.client_id)
            this.op.check['client'] = client.complete
            //console.log('check', this.op.check)
        },
        async initData(op) {
            let data = this.reset()
            if (!op){
                return data
            }
            if (op.client_id) {
                data.client.obj = await this.$store.state.$pouch.get('registry', op.client_id)
            }
            return data
        },
        /*async searchClient(){
            // serch by name - ispettori interni

            console.log('search client', this.ext_data.client.search)
            if (this.ext_data.client.search != undefined && this.ext_data.client.search.trim()!= '' && this.ext_data.client.search.trim().length > 2){
                this.c_loading = true
                let res = await searchByText(this.$store.state.$pouch, 'registry', 'clients/searchByText', this.ext_data.client.search)
                if (res != null) {
                    this.s_clients = res
                }
                this.c_loading = false
            }
        },*/
        closePIVADialog(client) {
            //console.log("************", client)
            if (client) {
                let added_client = {_id: this.piva_dialog.result[0].id, value: this.piva_dialog.result[0].value}
                this.$set(this.s_clients, this.s_clients.length, added_client)
                this.$set(this.op, 'client_id', this.piva_dialog.result[0].id)
                this.getLocations()
            }
            this.piva_dialog.open = false
            this.piva_dialog.show_result = false
        },
        openPIVADialog() {
            this.piva_dialog.search_piva = ""
            this.piva_dialog.open = true
            this.piva_dialog.result = null
            
        },
        async exactSearch(){
            this.piva_dialog.show_result = false
            this.piva_dialog.result = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['piva', this.piva_dialog.search_piva], false)
            this.piva_dialog.show_result = true
        },
        async getClientObj() {
            let obj = await this.$store.state.$pouch.get('registry', this.op.client_id)
            return obj
        },
        async getClients() {
            let selectors = ['client']
            if (!filterByOrg('client', 'list', this.$store.state.user.roles)) {
                selectors.push(['org', this.$store.state.user.org_id])
            }
            let sel_client = []
            if (this.client_id) {
                sel_client = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['client', this.client_id], false)    
            }
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'all_keys', selectors, false)
            
            let clients = [...new Set([...sel_client, ...res])]
            
            if (clients != null && clients.length >0) {
                clients = clients.map(item => { return { _id: item.id, value: item.value } })
                this.s_clients = orderByFields(clients, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            } else {
                this.s_clients = []
            }
            if (this.client_id) {
                await this.getLocations()
            }
        },
        async getLocations() {
            console.log(this.op.client_id)
            if (this.op.client_id) {
                let selectors = ['client', this.op.client_id]
                let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', selectors, false)
                if (res != null) {
                    res = res.map(item => { return { _id: item.id, value: item.value } })
                    console.log('res -', res)
                    this.s_locations = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
                } else {
                    this.s_locations = []
                }
            } else {
                this.s_locations = []
            }
        },
        async refreshLocation(sel_location) {
            await this.getLocations()
            this.op.location_id = sel_location._id
        },
        async refreshClient(sel_client) {
            this.op.client_id = sel_client._id
            await this.getClients()
        },
        
        async saveOperation() {
            try {
                this.save_error = false
                let date_op = new Date()
                Object.assign(this.op,this.$refs.registry.getData(), this.$refs.instrumentsSelection.getData())

                if (!this.op_id) {
                    let tag = date_op.getFullYear()+''+(date_op.getMonth()+1)+''+(date_op.getDate())+'_'+this.op.client_id
                    this.op.tags = [tag]
                    this.op.updated = date_op.getTime()
                    this.author = this.$store.state.user._id
                }
                this.op.updated = date_op.getTime()
                this.op.updated_by = this.$store.state.user._id
                let assigned_user = this.op.assigned[0] 
                // this.op.org_id = this.$store.state.users[assigned_user].org_id
                let docs_to_save = []
                await this.updateCheck()
                let client = await this.$store.state.$pouch.get('registry', this.op.client_id)
                // if(!client.ref_orgs.includes(this.$store.state.user.org_id)){
                //     client.ref_orgs.push(this.$store.state.user.org_id)
                //     docs_to_save.push(client)
                // }

                // for (let i_id of this.op.instrument_ids) {
                //     let instr = await this.$store.state.$pouch.get('registry', i_id)
                //     if(!instr.ref_orgs.includes(this.$store.state.user.org_id)){
                //         instr.ref_orgs.push(this.$store.state.user.org_id)
                //         docs_to_save.push(instr)
                //     }
                // }

                if(!client.ref_orgs.includes(this.op.org_id)){
                    client.ref_orgs.push(this.op.org_id)
                }
                docs_to_save.push(client)
                for (let loc of this.s_locations) {
                    let location = await this.$store.state.$pouch.get('registry', loc._id)
                    if(!location.ref_orgs.includes(this.op.org_id)){
                        location.ref_orgs.push(this.op.org_id)
                    }
                    docs_to_save.push(location)
                    
                }    
                for (let i_id of this.op.instrument_ids) {
                    let instr = await this.$store.state.$pouch.get('registry', i_id)
                    if(!instr.ref_orgs.includes(this.op.org_id)){
                        instr.ref_orgs.push(this.op.org_id)
                    }
                    docs_to_save.push(instr)
                }
                console.log("DOCS TO SAVE", docs_to_save)
                let res = await this.$store.state.$pouch.bulkDocs('registry', docs_to_save)
                
                let opRes = await this.$store.state.$pouch.put('operations', this.op)
                if (opRes.ok) {
                    //console.log("OPERATION ID",this.op._id)
                    this.op._rev = opRes.rev
                }
                //this.close()
                this.$router.push({path: "/operations/details", query: {"op_id": this.op._id, "back": this.back}})
            } catch(error) {
                this.save_error = true
                console.log('error', error)
            }
        },
        reset() {
            return  {
                sel_client: 'search',
                client: {
                    vobj:null,
                    obj: null,
                    search: ''
                }
            }
        },
        close() {
            this.$router.push({path: this.back})
        },
       
        updateValidity(registry_valid) {
            this.regValid = registry_valid
        },

        addContact(){
            this.$refs.contactEdit.openDialog(null, -1)
        },
        async updateContact(contact) {
            let updatedContact = _.cloneDeep(contact)
            let client = await this.$store.state.$pouch.get('registry', this.op.client_id)
            this.$set(client.contacts, contact.id, updatedContact)
            client.updated_by = this.$store.state.user._id
            client.updated = (new Date()).getTime()
            let res = await this.$store.state.$pouch.put('registry', client)
            this.$refs.locationEdit.getContacts()
            this.$refs.contactEdit.closeDialog()
        }
    },
    computed: {
        isValid() {
            return this.valid && this.regValid
        }
    },
    watch: {
    }
}
</script>